module.exports = __webpack_public_path__ + "img/client_3.a9b63be8.png";